import QRCode from 'qrcode';
export function qrDataUrl(text){
  const qr=QRCode.create(text,{errorCorrectionLevel:'M'}),size=qr.modules.size,quiet=4;let cells='';
  for(let y=0;y<size;y++)for(let x=0;x<size;x++)if(qr.modules.get(y,x))cells+=`M${x+quiet} ${y+quiet}h1v1h-1z`;
  const svg=`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size+8} ${size+8}" shape-rendering="crispEdges"><rect width="100%" height="100%" fill="white"/><path d="${cells}" fill="black"/></svg>`;
  return 'data:image/svg+xml;base64,'+btoa(svg);
}
let queue=Promise.resolve();
export function printDocument(html){
  const task=queue.then(()=>new Promise((resolve,reject)=>{
    const frame=document.createElement('iframe');frame.title='Documento para imprimir';frame.setAttribute('sandbox','allow-same-origin allow-modals');frame.style.cssText='position:fixed;right:0;bottom:0;width:1px;height:1px;border:0;opacity:0;pointer-events:none';
    let done=false;const cleanup=()=>{if(done)return;done=true;clearTimeout(watchdog);frame.remove();resolve();};
    // Un timeout NO equivale a una impresion aceptada. Conserva el trabajo pendiente.
    const watchdog=setTimeout(()=>{if(!done){done=true;frame.remove();reject(new Error('Chrome no confirmó el diálogo de impresión'));}},120000);
    frame.onload=async()=>{
      const win=frame.contentWindow;
      try {
        await Promise.race([Promise.all([...win.document.images].map(img=>img.complete?Promise.resolve():new Promise(r=>{img.onload=r;img.onerror=r;}))),new Promise(r=>setTimeout(r,1800))]);
        if(done)return;win.addEventListener('afterprint',cleanup,{once:true});win.focus();win.print();
      }catch(e){if(!done){done=true;clearTimeout(watchdog);frame.remove();reject(e);}}
    };
    frame.srcdoc=html;document.body.appendChild(frame);
  }));queue=task.catch(()=>{});return task;
}
export const escapeHtml=v=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
